/**
 * This file was auto-generated by Fern from our API Definition.
 */

/**
 * The value to compare against.
 */
export type EqualKeyTypeValue = 'ED25519' | 'P256' | 'P384';
export const EqualKeyTypeValue = {
    Ed25519: 'ED25519',
    P256: 'P256',
    P384: 'P384',
} as const;
